import { useMemo } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

interface IDataTableProps {
  data: any[];
  columns: any[];
  onRowClicked?: any;
  paginationPageSize?: number;
  filter?: boolean;
}

const DataTable = ({ data, columns, onRowClicked, paginationPageSize, filter }: IDataTableProps) => {

  const defaultColDef = useMemo(() => {
    return {
      filter: 'agTextColumnFilter',
      floatingFilter: filter ?? true,
    }
  }, []); // eslint-disable-line

  return (
    <div className="ag-theme-quartz imm_ag_grid_content">
      <AgGridReact
        rowData={data}
        columnDefs={columns}
        defaultColDef={defaultColDef}
        rowSelection="multiple"
        suppressRowClickSelection={true}
        pagination={true}
        onRowClicked={onRowClicked}
        paginationPageSize={paginationPageSize ?? 100}
        paginationPageSizeSelector={[100, 200, 300]}
      />
    </div>
  )
}

export default DataTable;